export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.f97a58c8.eot";